import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { setJwtToken } from "../../redux/features/jwtTokenSlice";
import { setUser } from "../../redux/features/userSlice";
import { UserBadge } from "../user/UserBadge";

const NavbarAccount = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  if (!user) {
    return (
      <div className="dropdown  dropdown-profile">
        <Link className="btn btn-outline-light btn-sm " to="/login">
          Se connecter
        </Link>
      </div>
    );
  }
  return (
    <div className="dropdown  dropdown-profile">
      <div
        className="nav-link dropdown-toggle"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {user.profile_media ? (
          <UserBadge user={user} noLink />
        ) : (
          <i
            className="fa-solid fa-circle-user text-white"
            style={{ fontSize: "2rem" }}
          ></i>
        )}
      </div>

      <ul className="dropdown-menu dropdown-menu-end">
        {user.athlete_id && (
          <li>
            <Link className="dropdown-item" to={`/athletes/${user.athlete_id}`}>
              Mon profil
            </Link>
          </li>
        )}
        <li>
          <Link className="dropdown-item" to="/settings/">
            Paramètres
          </Link>
        </li>
        <li>
          <hr className="dropdown-divider" />
        </li>
        <li>
          <Link
            className="dropdown-item"
            to="/"
            onClick={() => {
              localStorage.removeItem("jwt_token");
              dispatch(setJwtToken(null));
              dispatch(setUser(null));
              navigate("/");
            }}
          >
            Se déconnecter
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default NavbarAccount;
